/*********************** Custom JS for Boost AI Search & Discovery  ************************/

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useModulePlugin('FilterAPI', {
      name: 'Ensure params',
      apply(builder) {
        builder.on('beforeMethodCall', 'get', (payload) => {

          try { 
            const countryCode = Shopify.country;
          const currency = Shopify.currency.active;
          const currencyRate = Shopify.currency.rate;
            payload.args[0].country = countryCode
            payload.args[0].currency = currency
            payload.args[0].currency_rate = currencyRate
            payload.args[0].return_all_currency_fields = false
            
          } catch (error) {
            console.log(error)
          }
         
          
        });
      },
    });
    componentRegistry.useModulePlugin('SearchAPI', {
      name: 'ensure params',
      apply(builder) {
        builder.on('beforeMethodCall', 'searchInCollection', (payload) => {
          try { 
            const countryCode = Shopify.country;
          const currency = Shopify.currency.active;
          const currencyRate = Shopify.currency.rate;
            payload.args[0].country = countryCode
            payload.args[0].currency = currency
            payload.args[0].currency_rate = currencyRate
            payload.args[0].return_all_currency_fields = false
            
          } catch (error) {
            console.log(error)
          }
        });
        builder.on('beforeMethodCall', 'get', (payload) => {
          if (!payload.args[2]) {
            payload.args[2] = {};
          }
          
          try {
          const countryCode = Shopify.country;
          const currency = Shopify.currency.active;
          const currencyRate = Shopify.currency.rate;
            payload.args[2].country = countryCode
            payload.args[2].currency = currency
            payload.args[2].currency_rate = currencyRate
            payload.args[2].return_all_currency_fields = false
            
          } catch (error) {
            console.log(error)
          }
      
        });
      },
    });
  },
]);